"use strict";

exports.__esModule = true;
exports.default = void 0;

var last = function last(value) {
  return value === '' ? '' : value[value.length - 1];
};

var _default = last;
exports.default = _default;